export { default as InventoryRequestEmailEditTemplate } from './InventoryRequestEmailEditTemplate';
